enum Via {
  api = 'api',
  browserExtension = 'browser_extension',
  postMerged = 'postMerged',
  postUnmerged = 'postUnmerged',
  user = 'user',
  slack = 'slack',
}

export default Via;

export const isVia = (via: string): via is Via => {
  return Object.values(Via).includes(via as Via);
};
